import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .update-phone-modal {
    width: 380px;
    padding: 16px;
  }
  .add-phone-title {
    font-size: 16px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    margin-bottom: 10px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .update-phone-modal-inputs {
    width: 100%;
    padding-bottom: 16px;
  }

  .update-phone-modal-row {
    display: flex;
    padding-bottom: 10px;
  }
  .phone-modal-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .classB-input {
    margin-left: 8px;
  }
  .update-phone-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .update-phone-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .license-input {
    margin-bottom: 8px;
  }
`;

export default style;
